import React, { useEffect, useState } from "react"
import CurrencyFormatter from "../CurrencyFormatter"

const OrdersTab = ({ orders }) => {
  const [selectedOrder, setSelectedOrder] = useState(null)
  const [shipping, setShipping] = useState(null)
  // const [productVariants, setProductVariants] = useState([])
  // console.log({ productVariants })

  useEffect(() => {
    if (selectedOrder) {
      getShipping(selectedOrder)
    }
  }, [selectedOrder])

  async function getShipping(myorder) {
    const res = await fetch(
      `/.netlify/functions/bigcommerce?endpoint=/v2${myorder.shipping_addresses.resource}`,
      { credentials: "same-origin", mode: "same-origin" }
    )

    if (res.status === 200) {
      const response = await res.json()
      setShipping(response[0])
    }

    // for (let i = 0; i < myorder.products.info.length; i++) {
    //   const element = myorder.products.info[i]
    //   const productVariantRes = await fetch(
    //     `/.netlify/functions/bigcommerce?endpoint=/v3/catalog/products/${element.product_id}/variants/${element.variant_id}`,
    //     { credentials: "same-origin", mode: "same-origin" }
    //   )
    //   if (productVariantRes.status === 200) {
    //     const productVariantResponse = await productVariantRes.json()
    //     console.log({productVariantResponse})
    //     setProductVariants(prev => [...prev, productVariantResponse.data])
    //   }
    // }
  }

  if (orders.length === 0) {
    return (
      <div className="alert alert-dark" role="alert">
        You haven't placed any orders with us. When you do, their status will
        appear on this page.
      </div>
    )
  }

  if (selectedOrder) {
    return (
      <div>
        <p className="text-center">{`Order #${selectedOrder.id}`}</p>
        <div className="row">
          <div className="col-md-8">
            <p>Order Contents</p>
            <hr />

            {selectedOrder.products.info.map(product => (
              <div key={product.id}>
                <div className="d-flex justify-content-between">
                  <p className="mb-0">{`${product.quantity} X ${product.name}`}</p>
                  <p className="mb-0">
                    <CurrencyFormatter
                      currency={selectedOrder.currency_code}
                      amount={product.base_price}
                    />
                  </p>
                </div>
                <hr />
              </div>
            ))}

            <div className="mt-3">
              <div className="w-100 ml-auto" style={{ maxWidth: 350 }}>
                <p className="d-flex justify-content-between border-bottom">
                  <span>Subtotal:</span>
                  <span>
                    <CurrencyFormatter
                      currency={selectedOrder.currency_code}
                      amount={selectedOrder.subtotal_inc_tax}
                    />
                  </span>
                </p>
                <p className="d-flex justify-content-between border-bottom">
                  <span>Shipping:</span>
                  <span>
                    <CurrencyFormatter
                      currency={selectedOrder.currency_code}
                      amount={selectedOrder.shipping_cost_inc_tax}
                    />
                  </span>
                </p>
                <p className="d-flex justify-content-between">
                  <span>Grand Total:</span>
                  <span>
                    <CurrencyFormatter
                      currency={selectedOrder.currency_code}
                      amount={selectedOrder.total_inc_tax}
                    />
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div>
              <p>Order Details</p>
              <hr />
              <div>
                <p className="mb-0">
                  <span className="small text-muted">Order status: </span>
                  <span>{selectedOrder.custom_status}</span>
                </p>
                <p className="mb-0">
                  <span className="small text-muted">Order date: </span>
                  <span>
                    {new Date(selectedOrder.date_created).toLocaleDateString(
                      "en-US"
                    )}
                  </span>
                </p>
                <p className="mb-0">
                  <span className="small text-muted">Order total: </span>
                  <span>
                    <CurrencyFormatter
                      currency={selectedOrder.currency_code}
                      amount={selectedOrder.total_inc_tax}
                    />
                  </span>
                </p>
                <p className="mb-0">
                  <span className="small text-muted">Payment method: </span>
                  <span>{selectedOrder.payment_method}</span>
                </p>
                <button className="btn btn-sm btn-outline-dark mt-3">
                  Print Invoice
                </button>
              </div>
            </div>

            <div className="mt-3">
              <p>Ship To</p>
              <hr />
              <div>
                <p className="mb-0">
                  {[shipping?.first_name, shipping?.last_name].join(" ")}
                </p>
                <p className="mb-0">{shipping?.street_1}</p>
                {shipping?.street_2 && (
                  <p className="mb-0">{shipping?.street_2}</p>
                )}
                <p className="mb-0">
                  {`${shipping?.city}, ${shipping?.state} ${shipping?.zip}`}
                </p>
                <p className="mb-0">{shipping?.country}</p>
              </div>
            </div>

            <div className="mt-3">
              <p>Bill To</p>
              <hr />
              <div>
                <p className="mb-0">
                  {[
                    selectedOrder.billing_address.first_name,
                    selectedOrder.billing_address.last_name,
                  ].join(" ")}
                </p>
                <p className="mb-0">{selectedOrder.billing_address.street_1}</p>
                {selectedOrder.billing_address.street_2 && (
                  <p className="mb-0">
                    {selectedOrder.billing_address.street_2}
                  </p>
                )}
                <p className="mb-0">
                  {`${selectedOrder.billing_address.city}, ${selectedOrder.billing_address.state} ${selectedOrder.billing_address.zip}`}
                </p>
                <p className="mb-0">{selectedOrder.billing_address.country}</p>
              </div>
            </div>

            <div className="mt-3">
              <p>Order Comments</p>
              <hr />
              <p>{selectedOrder?.customer_message}</p>
            </div>

            <div className="mt-3">
              <p>Actions</p>
              <hr />
              <button className="btn btn-sm btn-outline-dark">Reorder</button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="w-100 m-auto py-3" style={{ maxWidth: 800 }}>
        {orders.map(order => {
          return (
            <div key={order.id} className="row border-bottom mb-3">
              <div className="col-md-8">
                <a
                  onClick={() => setSelectedOrder(order)}
                  href="#"
                  className="mb-0 text-dark"
                >{`Order #${order.id}`}</a>
                <p className="mb-0">
                  {`${order.products.info.length} ${
                    order.products.info.length > 1 ? "products" : "product"
                  } totaling `}
                  <CurrencyFormatter
                    currency={order.currency_code}
                    amount={order.total_inc_tax}
                  />
                </p>
                <div className="d-flex flex-wrap mt-3">
                  <div className="mr-3">
                    <p className="small text-muted mb-0">ORDER PLACED</p>
                    <p className="mb-0">
                      {new Date(order.date_created).toLocaleDateString("en-US")}
                    </p>
                  </div>
                  <div>
                    <p className="small text-muted mb-0">LAST UPDATE</p>
                    <p className="mb-0">
                      {new Date(order.date_modified).toLocaleDateString(
                        "en-US"
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 text-right">
                <p className="m-0">
                  <span className="badge badge-secondary">
                    {order.custom_status}
                  </span>
                </p>
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default OrdersTab
